import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {LocationSet} from '@emm/core/models/location-set.model';
import {APIParams} from '@emm/core/util/api-constants';
import {standardRetry} from '@emm/core/util/rx.util';


@Injectable({ providedIn: 'root' })
export class LocationSetService {

    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {}



    getAllLocationSetsByTag(tag: string): Observable<LocationSet[]> {
        const url = `${this.apiUrl}${APIParams.GetAllLocationSetsByTag(tag)}`;
        return this.http.get(url).pipe(
            // TODO: Make interface objects for http responses
            map((response: any) => response),
            standardRetry()
        );
    }



    getLocationsByParentMMS(consumer: string): Observable<LocationSet[]> {
        return this.http
            .get(`${this.apiUrl}/locations/search-by-source/${consumer}`)
            .pipe(
                map((response) => response),
                standardRetry()
            );
    }


    getLocationsByParent(parentTag: string): Observable<LocationSet[]> {
        return this.http
            .get(`${this.apiUrl}/locations/findChildLocationsOfParent?tag=${parentTag}`)
            .pipe(
                map((response) => response),
                standardRetry()
            );
    }



    public getLocationsByParents(parentTag: string): Observable<LocationSet[]> {
        return this.http
            .get(`${this.apiUrl}/locations/findChildLocationsOfParents?tags=${parentTag}`)
            .pipe(
                map((response) => response),
                standardRetry()
            );
    }



    filterLocations(filter: string, size: number): Observable<LocationSet[]> {
        return this.http
            .get(
                `${this.apiUrl}/locations/search/filter?q=${filter}&projection=location-basics&sort=name&sort=tag&size=${size}`
            )
            .pipe(
                map((response) => response),
                standardRetry()
            );
    }



    getLocationsByStatusAndValue(statusTag, value, pageIndex, pageSize): Observable<any> {
        const requestOptions = {
            params: {
                status: statusTag,
                value,
                projection: 'details',
                page: pageIndex,
                size: pageSize,
            },
        };
        return this.http
            .get(
                `${this.apiUrl}/menu-location-status/findByStatusTagAndValueOrderByDateUpdatedAsc`,
                requestOptions
            )
            .pipe(
                map((response) => response),
                standardRetry()
            );
    }



    countLocationsByStatusAndValue(statusTag, value): Observable<any> {
        const requestOptions = {
            params: { status: statusTag, value },
        };
        return this.http
            .get(`${this.apiUrl}/menu-location-status/search/countByStatusTagAndValue`, requestOptions)
            .pipe(standardRetry());
    }



    getLocationStatus(locationTag, statusTag): Observable<any> {
        const requestOptions = {
            params: { location: locationTag, status: statusTag, projection: 'details' },
        };
        return this.http
            .get(
                `${this.apiUrl}/menu-location-status/search/findByLocationTagAndStatusTag`,
                requestOptions
            )
            .pipe(standardRetry());
    }



    updateLocationSet(tag: string, updates: any): Observable<LocationSet> {
        return this.http.put(`${this.apiUrl}/locationsets/${tag}`, updates).pipe(standardRetry());
    }



    deleteLocationSet(tag: string): Observable<any> {
        return this.http.delete(`${this.apiUrl}/locationsets/${tag}`).pipe(standardRetry());
    }



    removeChildLocation(parentTag: string, childTag: string): Observable<any> {
        return this.http
            .delete(`${this.apiUrl}/locationsets/${parentTag}/${childTag}`)
            .pipe(standardRetry());
    }


    removeChildLocations(parentTag: string, childTags: string[]): Observable<any> {
        return this.http
            .delete(`${this.apiUrl}/locationsets/${parentTag}/children`, {
                body: childTags
            })
            .pipe(standardRetry());
    }


    addChildLocations(parentTag: string, childTags: any): Observable<any> {
        return this.http
            .post(`${this.apiUrl}/locationsets/${parentTag}`, childTags)
            .pipe(standardRetry());
    }



    createLocationSet(locationSet): Observable<any> {
        return this.http
            .post(`${this.apiUrl}/locationsets`, locationSet, { responseType: 'text' })
            .pipe(standardRetry());
    }

    disableLocationSet(tag: string, disabled: boolean): Observable<any> {
        return this.http
            .put(`${this.apiUrl}/locationsets/${tag}/disabled/${disabled}`, null)
            .pipe(standardRetry());
    }

    public getMenuSource(storeNum: any): Observable<any> {
        return this.http.get(`${this.apiUrl}/master-menu/menu/source/${storeNum}`, { observe: 'response' as const });
    }


}
